import { useMutation, useQueryClient } from "react-query";
import axios from "axios";

const enablePovUser = async (payload) => {
  try {
    const response = await axios({
      method: "get",
      url: process.env.REACT_APP_API + "/api/v1/pointOfSaleUser/enable",
      params: {
        userId: payload.id,
        pointOfSaleUserId: payload.pointOfSaleId,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("accessToken"),
      },
    });
  } catch (error) {
    console.log(error.response);
  }
};

export const useEnablePovUser = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: enablePovUser,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["get-pov-user"] });
    },
  });
};
